type Props = {
  blok: Subheading;
};

const Subheading: React.FC<Props> = ({ blok }) => {
  return (
    <div className="grid-section pb-4 pt-6 md:pb-6 md:pt-9">
      <div className="col-span-12 md:col-span-4 md:col-start-4">
        <h2 className="text-md font-bold">{blok.text}</h2>
      </div>
    </div>
  );
};

export default Subheading;
